import type { CourseProgressElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { DEMO_MODE } from 'services/Store/Project/constants'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './CourseProgressElement'
import type { CourseProgressDemoType } from './courseProgressTypes'

const DEMO_VALUE: CourseProgressElementValue = {
  percentPosition: 'right',
}

const CourseProgressDemo: CourseProgressDemoType = ({ styles, feedback, fonts }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.courseProgress.type}-demo`,
        type: CONFIG_ELEMENTS.courseProgress.type,
        value: DEMO_VALUE,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default CourseProgressDemo
